import qwest from 'qwest';
import {createSearchParams} from 'helpers/searchParams';

let onSuccess = () => {
  return (xhr, response) => {
    if (response.success) {
      return response.data;
    }
    throw response;
  };
};

let onError = () => {
  throw {
    code: -1,
    data: null,
    message: 'Unexpected Error',
    success: false,
  };
};

let ReportApi = {

  getSimpleWaterTestsReport(id, start, end) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.get(`v1/newReports/WaterTests/Simple?branchList=${id}&start=${start}&end=${end}`)
      .then(onSuccess(), onError);
  },

  getSimpleFollowUpReport(id, start, end, poolTypes = null, problems = {}) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.post(`/SimpleReport/FollowUpSummary?branchList=${id}&poolTypes=${poolTypes}` +
      `&start=${start}&end=${end}`, problems)
      .then(onSuccess(), onError);
  },

  getSimpleEmployeeMetricsReport(id, start, end) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.get(`/SimpleReport/SimpleEmployeeMetrics?branchList=${id}&start=${start}&end=${end}`)
      .then(onSuccess(), onError);
  },

  getSimpleCustomerReport(id) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.get(`v1/newReports/Customer/Simple?branchList=${id}`)
      .then(onSuccess(), onError);
  },

  getAccountListSummary(id, pool = null, active = true) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.get(`/v1/newReports/Customer/AccountListSummary?branchList=${id}&pool=${pool}&active=${active}`)
      .then(onSuccess(), onError);
  },

  getNewAccountListSummary(start, end, id, pool = null, active = true) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.get(`/v1/newReports/Customer/NewAccountListSummary?start=${start}&end=${end}&branchList=${id}&pool=${pool}&active=${active}`)
      .then(onSuccess(), onError);
  },

  getAccountListExport(locale, id, pool = null, active = true) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    window.open(`/v1/newReports/Customer/AccountListExport?branchList=${id}&pool=${pool}&active=${active}&locale=${locale}`);
  },

  getNewAccountListExport(locale, start, end, id, pool = null, active = true, newAccounts = false) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    window.open(`/v1/newReports/Customer/AccountListExportDates?start=${start}` +
      `&end=${end}&branchList=${id}&pool=${pool}&active=${active}&newAccounts=${newAccounts}&locale=${locale}`);
  },
  getFollowUpReport(id, start, end, poolTypes = null, problems = {}, tester = '', CompletedFollowUps = false) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.post(`v1/newReports/FollowUp/FollowUpReport?branchList=${id}&poolTypes=${poolTypes}` +
      `&start=${start}&end=${end}&tester=${tester}&CompletedFollowUps=${CompletedFollowUps}`, problems)
      .then(onSuccess(), onError);
  },
  getFollowUpReportExport(locale, id, start, end, poolTypes = null, problems = {},tester = '',CompletedFollowUps = false) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    window.open(`v1/newReports/FollowUp/FollowUpReportExport?branchList=${id}&poolTypes=${poolTypes}&locale=${locale}` +
      `&start=${start}&end=${end}&tester=${tester}&CompletedFollowUps=${CompletedFollowUps}`, problems);
  },

  getMissingCustomersReportSummary(id, start, end, since, poolTypes = null) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.post(`v1/newReports/MissingCustomer/Summary?branchList=${id}&poolTypes=${poolTypes}` +
      `&start=${start}&end=${end}&since=${since}`)
      .then(onSuccess(), onError);
  },

  getMissingCustomersReport(id, start, end, since, poolTypes = null, page = 1, count = 20) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.post(`v1/newReports/MissingCustomer/Report?branchList=${id}&poolTypes=${poolTypes}` +
      `&start=${start}&end=${end}&page=${page}&count=${count}&since=${since}`)
      .then(onSuccess(), onError);
  },

  getMissingCustomersReportExport(locale, id, start, end, since, poolTypes = null) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    window.open(`v1/newReports/MissingCustomer/Export?branchList=${id}&poolTypes=${poolTypes}` +
      `&start=${start}&end=${end}&since=${since}&locale=${locale}`);
  },

  getPastDueReportSummary(id, start, end, poolTypes = null) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.post(`v1/newReports/PastDue/Summary?branchList=${id}&poolTypes=${poolTypes}` +
      `&start=${start}&end=${end}`)
      .then(onSuccess(), onError);
  },

  getPastDueReport(id, start, end, poolTypes = null, page = 1, count = 20) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.post(`v1/newReports/PastDue/Report?branchList=${id}&poolTypes=${poolTypes}` +
      `&start=${start}&end=${end}&page=${page}&count=${count}`)
      .then(onSuccess(), onError);
  },

  getPastDueReportExport(locale, id, start, end, poolTypes = null) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    window.open(`v1/newReports/PastDue/Export?branchList=${id}&poolTypes=${poolTypes}` +
      `&start=${start}&end=${end}&locale=${locale}`);
  },

  getWaterTestTotal(id, start, end, groupby = 'day', poolType = null, customerType = null) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.get(`/v1/newReports/WaterTests/WaterTestTotal?branchList=${id}&start=${start}&end=${end}` +
      `&groupby=${groupby}&poolType=${poolType}&customerType=${customerType}`)
      .then(onSuccess(), onError);
  },

  getSimpleEmailReport(start, end, store) {
    return qwest.get(`/SimpleReport/SimpleEmailReport?store=${store}&start=${start}&end=${end}`)
      .then(onSuccess(), onError);
  },

  getSimpleTruBlueReport(id, start, end, truBlueStatus = 0) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.get(`/SimpleReport/SimpleTruBlueReport?branchList=${id}&start=${start}&end=${end}&truBlueStatus=${truBlueStatus}`)
      .then(onSuccess(), onError);
  },

  getSalesPerformance(branches, systems, start, end) {
    const url = `v1/newReports/Sales/SalesPerformance?branchList=${branches}&systemList=${systems}&start=${start}&end=${end}`;

    return qwest.get(url).then(onSuccess(), onError);
  },
  getSalesPerformanceExport(locale, branches, pool, start , end) {
    window.open(`/v1/newReports/Sales/ExportSalesPerformance?start=${start}&end=${end}&branchList=${branches}&systemList=${pool}&locale=${locale}`);
  },
  getLostCustomerReportSummary(branches, systems, start, end, since) {
    const url = `v1/newReports/Sales/LostCustomerSummary?branchList=${branches}&systemList=${systems}&start=${start}&end=${end}&since=${since}`;

    return qwest.get(url).then(onSuccess(), onError);
  },

  getLostCustomerReport(branches, systems, start, end, since) {
    const url = `v1/newReports/Sales/LostCustomerReport?branchList=${branches}&systemList=${systems}&start=${start}&end=${end}&since=${since}`;

    return qwest.get(url).then(onSuccess(), onError);
  },

  getLostCustomerReportExport(locale, branches, systems, start, end, since) {
    const url = `v1/newReports/Sales/ExportLostCustomerReport?branchList=${branches}&systemList=${systems}` +
      `&start=${start}&end=${end}&since=${since}&locale=${locale}`;

    window.open(url);
  },

  getProductSalesReport(branches, categories, start, end) {
    const url = `v1/newReports/BioGuard/ProductSalesReport?branchList=${branches}&categoryList=${categories}&start=${start}&end=${end}`;

    return qwest.get(url).then(onSuccess(), onError);
  },

  getProductSalesReportExport(locale, branches, categories, start, end) {
    const url = `v1/newReports/BioGuard/ExportProductSalesReport?branchList=${branches}&categoryList=${categories}&start=${start}&end=${end}&locale=${locale}`;

    window.open(url);
  },

  getProductRecommendationReport(year, branches, category) {
    const url = `v1/newReports/BioGuard/ProductRecommendationReport?branchList=${branches}&category=${category}&year=${year}`;

    return qwest.get(url).then(onSuccess(), onError);
  },

  getProductRecommendationReportExport(locale, year, branches, category) {
    const url = `v1/newReports/BioGuard/ExportProductRecommendationReport?branchList=${branches}&category=${category}&year=${year}&locale=${locale}`;

    window.open(url);
  },

  getWaterTotalAnalyses(dateFrom, dateTo, branch, systemType) {
    return qwest.get(`v1/newReports/WaterAnalyses/Summary?start=${dateFrom}&end=${dateTo}&store=${branch}&systemType=${systemType}`)
    .then(onSuccess(), onError);
  },

  getWaterTotalAnalysesExport(locale, dateFrom, dateTo, branch, systemType) {
    window.open(`v1/newReports/WaterAnalyses/ExportReport?start=${dateFrom}&end=${dateTo}&store=${branch}&systemType=${systemType}&locale=${locale}`);
  },

  getWaterAnalysisAccounts(dateFrom, dateTo, branch, systemType) {
    return qwest.get(`v1/newReports/water/AnalysisAccounts/Summary?start=${dateFrom}&end=${dateTo}&store=${branch}&systemType=${systemType}`, {
      timeout: 120000,
    })
      .then(onSuccess(), onError);
  },

  getWaterAnalysisAccountsExport(locale, dateFrom, dateTo, branch, systemType) {
    window.open(`v1/newReports/water/AnalysisAccounts/ExportReport?start=${dateFrom}&end=${dateTo}&store=${branch}&systemType=${systemType}&locale=${locale}`);
  },

  getWaterAnalysesByEmployeeSummary(dateFrom, dateTo, branch) {
    return qwest.get(`v1/newReports/water/AnalysesByEmployee/Summary?start=${dateFrom}&end=${dateTo}&store=${branch}`)
      .then(onSuccess(), onError);
  },

  getWaterAnalysesByEmployeeExport(locale, dateFrom, dateTo, branch) {
    window.open(`v1/newReports/water/AnalysesByEmployee/ExportReport?start=${dateFrom}&end=${dateTo}&store=${branch}&locale=${locale}`);
  },

  getOutboundEmailsSummary(dateFrom, dateTo, branch) {
    return qwest.get(`v1/newReports/communications/OutboundEmails/Summary?start=${dateFrom}&end=${dateTo}&store=${branch}`)
      .then(onSuccess(), onError);
  },

  getOutboundEmailsReport(locale, dateFrom, dateTo, branch) {
    window.open(`v1/newReports/communications/OutboundEmails/ExportReport?start=${dateFrom}&end=${dateTo}&store=${branch}&locale=${locale}`);
  },

  getMissedProductSalesReport(dateFrom, dateTo, branch, categoryType) {
    return qwest.get(`v1/newReports/BioGuard/MissedProductSalesReport?branchList=${branch}&categoryType=${categoryType}&start=${dateFrom}&end=${dateTo}`)
      .then(onSuccess(), onError);
  },

  getMissedProductSalesReportExport(locale, dateFrom, dateTo, branch, categoryType) {
    window.open(`v1/newReports/BioGuard/ExportMissedProductSalesReport?branchList=${branch}&categoryType=${categoryType}` +
      `&start=${dateFrom}&end=${dateTo}&locale=${locale}`);
  },

  getSeasonsUsageReportPDFGeneration(branch = null, truBlueStatus = null, active = 'all') {
    return qwest.get(`v1/newReports/BioGuard/SeasonsUsageReportPDFGeneration${createSearchParams({
      branch, truBlueStatus, active,
    })}`)
      .then(onSuccess(), onError);
  },

  getSeasonsUsageReportPDFHistory() {
    return qwest.get(`v1/newReports/BioGuard/SeasonsUsageReportPDFHistory`)
      .then(onSuccess(), onError);
  },

  getOptOutEmailsReport(id, optedOutEmailType) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    return qwest.get(`v1/newReports/communications/OptOutEmails/OptOutReport?branchList=${id}&optedOutEmailType=${optedOutEmailType}`)
      .then(onSuccess(), onError);
  },

  getOptOutEmailsReportExport(locale, id, optedOutEmailType) {
    if (typeof id === 'object') {
      id = id.join('&branchList=');
    }
    window.open(`v1/newReports/communications/OptOutEmails/OptOutReportExport?branchList=${id}&poolTypes=${optedOutEmailType}&locale=${locale}`);
  },
};

export default ReportApi;
